import { Stack, Tag, Text } from '@chaine/keychaine';
import * as React from 'react';
export const SectionStats = (props) => {
    const { labelColor, statTextColor, statSubtext, statText } = props;
    return (React.createElement(Stack, { spacing: { base: '20', md: '20' }, justify: "center" },
        React.createElement(Stack, { spacing: 0 },
            React.createElement(Tag, { variant: "outline", colorScheme: labelColor, borderRadius: "full", size: "md", maxW: "fit-content" }, "Did you know?"),
            React.createElement(Text, { fontSize: { base: '2.5rem', md: '4.5rem' }, fontWeight: "semibold", color: statTextColor }, statText),
            React.createElement(Text, { fontSize: { base: 'xl', md: '3xl' }, fontWeight: "semibold", color: "text.primary" }, statSubtext))));
};
